"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5687],{

/***/ 99591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pu": function() { return /* binding */ DISCONNECT_PAYMENT_PROCESSOR; },
/* harmony export */   "QF": function() { return /* binding */ GET_PAYMENT_SETTINGS; },
/* harmony export */   "jL": function() { return /* binding */ COMPLETE_GOCARDLESS_CONNECTION; },
/* harmony export */   "mR": function() { return /* binding */ GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT; },
/* harmony export */   "n_": function() { return /* binding */ CREATE_PAYMENT_PROCESSOR_CONNECT_LINK; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPaymentSettings {\n    getPaymentSettings {\n      stripe {\n        processor\n        configured\n        ready\n        organisationId\n        reason\n      }\n      gocardless {\n        processor\n        configured\n        ready\n        organisationId\n        reason\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreatePaymentProcessorConnectLink($processor: PaymentProcessor!) {\n    createPaymentProcessorConnectLink(processor: $processor) {\n      redirectUrl\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CompleteGoCardlessConnection(\n    $input: CompleteGoCardlessConnectionInput!\n  ) {\n    completeGoCardlessConnection(input: $input) {\n      success\n      error\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPaymentProcessorDisconnectImpact($processor: PaymentProcessor!) {\n    getPaymentProcessorDisconnectImpact(processor: $processor) {\n      eventId\n      title\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DisconnectPaymentProcessor($processor: PaymentProcessor!) {\n    disconnectPaymentProcessor(processor: $processor)\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const GET_PAYMENT_SETTINGS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
const CREATE_PAYMENT_PROCESSOR_CONNECT_LINK = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
const COMPLETE_GOCARDLESS_CONNECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
const GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
const DISCONNECT_PAYMENT_PROCESSOR = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());


/***/ }),

/***/ 98749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CreateEventStage; }
/* harmony export */ });
var CreateEventStage;
(function(CreateEventStage) {
    CreateEventStage["Space"] = "SPACE";
    CreateEventStage["Type"] = "TYPE";
    CreateEventStage["Details"] = "DETAILS";
    CreateEventStage["Communications"] = "COMMUNICATIONS";
    CreateEventStage["Preview"] = "PREVIEW";
})(CreateEventStage || (CreateEventStage = {}));


/***/ }),

/***/ 25687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ EventEditorProvider; },
  "O": function() { return /* binding */ useEventEditor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./components/base/GoogleTags.tsx
var GoogleTags = __webpack_require__(507);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./graphql/events/applyEventPatch.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ApplyEventPatch($input: ApplyEventPatchInput!) {\n    applyEventPatch(input: $input) {\n      success\n      conflicts {\n        path\n        expected\n        actual\n        message\n      }\n      event {\n        eventId\n        organizerId\n        isPublished\n        isPremium\n        isComplete\n        dateCreated\n        notifyOrganiser\n        availableTickets {\n          tickets {\n            ticketTitle\n            totalQuantity\n            remaining\n            discountCodes {\n              title\n              type\n              remaining\n            }\n          }\n        }\n        event {\n          bannerImage\n          description\n          eventMainColour\n          eventBackgroundColour\n          eventTextColour\n          endDateTime\n          registrationCloseDateTime\n          shortDescription\n          startDateTime\n          entryDateTime\n          title\n          organizationName\n          thumbnailImage\n          publiclyListed\n          currency\n          eventLocation\n          eventLocationMapUrl\n          eventLocationMapLink\n          donationUrl\n          eventType\n          blackbaudId\n          timeZone\n          timeZoneId\n          isInternal\n          internalLocation\n          showAttendeeBox\n        }\n        discounts {\n          title\n          type\n          percentage\n          quantity\n          tickets\n          code\n        }\n        registrationFields {\n          name\n          type\n          unique\n          dateOnly\n          visibleOnAttendeeList\n          required\n          options {\n            value\n            label\n          }\n        }\n        fundraising {\n          enabled\n          id\n          title\n          description\n          goal\n          feeAbsorption\n          programs {\n            title\n            description\n            goal\n            media {\n              title\n              body\n              platform\n              url\n            }\n            active\n            enabled\n          }\n          media {\n            title\n            body\n            platform\n            url\n          }\n        }\n        tickets {\n          price\n          ticketType\n          title\n          quantity\n          allowMultiplePurchase\n        }\n        speakers {\n          userId\n          email\n          name\n          organization\n          position\n          profileImage\n          ticketType\n          bio\n        }\n        stages {\n          class\n          description\n          holdingVideoUrl\n          title\n        }\n        sponsors {\n          description\n          facebookUrl\n          linkedinUrl\n          logoUrl\n          title\n          twitterUrl\n          websiteUrl\n          ondemandContent {\n            url\n            title\n            description\n            id\n          }\n        }\n        sessions {\n          description\n          endDateTime\n          speakers {\n            userId\n            email\n            name\n            organization\n            position\n            profileImage\n            ticketType\n            bio\n          }\n          stage {\n            class\n            description\n            holdingVideoUrl\n            title\n          }\n          startDateTime\n          title\n          isBreak\n        }\n        breakoutRooms {\n          thumbnailImage\n          description\n          maxAttendees\n          title\n        }\n        communications {\n          socials {\n            platform\n            url\n          }\n          announcements {\n            title\n            body\n          }\n        }\n        ondemandContent {\n          id\n          url\n          title\n          description\n        }\n        attendees {\n          email\n          name\n          profileImage\n          ticketTitle\n          invitationSentDatetime\n          registered\n          checkInStatus\n          checkInDatetime\n          ticketCode\n          isAdditionalGuest\n          userId\n          orderId\n          registrationVisible\n          requireRegistrationFields\n        }\n        notifications {\n          title\n          timestamp\n          notificationType\n          status\n        }\n        emailTemplates {\n          templateId\n          content\n          title\n          trigger\n          enabled\n          data\n          sentDateTime\n          schedule {\n            scheduleId\n            runAt\n            status\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const APPLY_EVENT_PATCH = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./graphql/events/createEvent.ts
var events_createEvent = __webpack_require__(80007);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/deleteEventById.ts

const DELETE_EVENT_BY_ID = (0,_generated/* graphql */.B)("\n  mutation deleteEventById($input: DeleteEventByIdInput!) {\n    deleteEventById(input: $input)\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/duplicateEventById.ts

const DUPLICATE_EVENT_BY_ID = (0,_generated/* graphql */.B)("\n  mutation duplicateEventById($eventId: String!) {\n    duplicateEventById(eventId: $eventId) {\n      success\n      event {\n        eventId\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/GetEventByIdForEditor.ts

function GetEventByIdForEditor_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getEventByIdForEditor($input: GetEventByIdInput!) {\n    getEventById(input: $input) {\n      eventId\n      organizerId\n      isPublished\n      isPremium\n      isComplete\n      dateCreated\n      notifyOrganiser\n      paymentProcessor\n      availableTickets {\n        tickets {\n          ticketTitle\n          totalQuantity\n          remaining\n          discountCodes {\n            title\n            type\n            remaining\n          }\n        }\n      }\n      event {\n        bannerImage\n        description\n        eventMainColour\n        eventBackgroundColour\n        eventTextColour\n        endDateTime\n        registrationCloseDateTime\n        shortDescription\n        startDateTime\n        entryDateTime\n        title\n        organizationName\n        thumbnailImage\n        publiclyListed\n        currency\n        eventLocation\n        eventLocationMapUrl\n        eventLocationMapLink\n        donationUrl\n        eventType\n        blackbaudId\n        timeZone\n        timeZoneId\n        isInternal\n        internalLocation\n        showAttendeeBox\n      }\n      discounts {\n        title\n        type\n        percentage\n        quantity\n        tickets\n        code\n      }\n      registrationFields {\n        name\n        type\n        unique\n        dateOnly\n        visibleOnAttendeeList\n        required\n        options {\n          value\n          label\n        }\n      }\n      fundraising {\n        enabled\n        id\n        title\n        description\n        goal\n        feeAbsorption\n        programs {\n          title\n          description\n          goal\n          media {\n            title\n            body\n            platform\n            url\n          }\n          active\n          enabled\n        }\n        media {\n          title\n          body\n          platform\n          url\n        }\n      }\n      tickets {\n        price\n        ticketType\n        title\n        quantity\n        allowMultiplePurchase\n      }\n      speakers {\n        userId\n        email\n        name\n        organization\n        position\n        profileImage\n        ticketType\n        bio\n      }\n      stages {\n        class\n        description\n        holdingVideoUrl\n        title\n      }\n      sponsors {\n        description\n        facebookUrl\n        linkedinUrl\n        logoUrl\n        title\n        twitterUrl\n        websiteUrl\n        ondemandContent {\n          url\n          title\n          description\n          id\n        }\n      }\n      sessions {\n        description\n        endDateTime\n        speakers {\n          userId\n          email\n          name\n          organization\n          position\n          profileImage\n          ticketType\n          bio\n        }\n        stage {\n          class\n          description\n          holdingVideoUrl\n          title\n        }\n        startDateTime\n        title\n        isBreak\n      }\n      breakoutRooms {\n        thumbnailImage\n        description\n        maxAttendees\n        title\n      }\n      communications {\n        socials {\n          platform\n          url\n        }\n        announcements {\n          title\n          body\n        }\n      }\n      ondemandContent {\n        id\n        url\n        title\n        description\n      }\n      attendees {\n        email\n        name\n        profileImage\n        ticketTitle\n        invitationSentDatetime\n        registered\n        checkInStatus\n        checkInDatetime\n        ticketCode\n        isAdditionalGuest\n        userId\n        orderId\n        registrationVisible\n        requireRegistrationFields\n      }\n      notifications {\n        title\n        timestamp\n        notificationType\n        status\n      }\n      emailTemplates {\n        templateId\n        content\n        title\n        trigger\n        enabled\n        data\n        sentDateTime\n        schedule {\n          scheduleId\n          runAt\n          status\n        }\n      }\n    }\n  }\n"
    ]);
    GetEventByIdForEditor_templateObject = function() {
        return data;
    };
    return data;
}

const GET_EVENT_BY_ID_FOR_EDITOR = (0,lib/* gql */.Ps)(GetEventByIdForEditor_templateObject());

;// CONCATENATED MODULE: ./graphql/events/syncEventAttendeesWithZapier.ts

const SYNC_EVENT_ATTENDEES_WITH_ZAPIER = (0,_generated/* graphql */.B)("\n  mutation SyncEventAttendeesWithZapier($eventId: String!) {\n    syncEventAttendeesWithZapier(eventId: $eventId) {\n      success\n      attendeesSynced\n      attendanceUpdatesSynced\n      error\n    }\n  }\n");

// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./graphql/payment/paymentSettings.ts
var payment_paymentSettings = __webpack_require__(99591);
// EXTERNAL MODULE: ./graphql/users/GetUsersByIds.ts
var GetUsersByIds = __webpack_require__(50116);
// EXTERNAL MODULE: ./libs/CreateEventContext.tsx
var CreateEventContext = __webpack_require__(4568);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
// EXTERNAL MODULE: ./libs/Utility/validation.ts
var validation = __webpack_require__(49532);
// EXTERNAL MODULE: ./libs/useBlackBaud.ts + 3 modules
var useBlackBaud = __webpack_require__(5834);
// EXTERNAL MODULE: ./libs/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(3830);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./libs/paymentFeatureFlags.ts
var paymentFeatureFlags = __webpack_require__(52992);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./libs/EventTime/index.ts + 26 modules
var EventTime = __webpack_require__(26647);
// EXTERNAL MODULE: ./libs/CreateEvent/CreateEventStage.ts
var CreateEventStage = __webpack_require__(98749);
;// CONCATENATED MODULE: ./libs/CreateEvent/eventPatch.ts



const cloneJson = (value)=>value === undefined ? value : JSON.parse(JSON.stringify(value));
const isPlainObject = (value)=>value !== null && typeof value === "object" && !Array.isArray(value);
const canonicalizePatchValue = (value)=>{
    if (Array.isArray(value)) return value.map(canonicalizePatchValue);
    if (value === null || value === undefined) return undefined;
    if (!isPlainObject(value)) return value;
    return Object.entries(value).reduce((payload, param)=>{
        let [key, child] = param;
        if (key === "__typename") return payload;
        const canonicalChild = canonicalizePatchValue(child);
        if (canonicalChild !== undefined) payload[key] = canonicalChild;
        return payload;
    }, {});
};
const hasConfiguredRegistrationOptions = (field)=>{
    return Array.isArray(field === null || field === void 0 ? void 0 : field.options) && field.options.some((option)=>{
        if (typeof option === "string") return option.trim() !== "";
        return [
            option === null || option === void 0 ? void 0 : option.label,
            option === null || option === void 0 ? void 0 : option.value
        ].some((value)=>typeof value === "string" && value.trim() !== "");
    });
};
var ref;
const normalizeRegistrationFields = (fields)=>{
    return (fields !== null && fields !== void 0 ? fields : []).map((field)=>{
        return {
            ...field,
            type: (ref = field === null || field === void 0 ? void 0 : field.type) !== null && ref !== void 0 ? ref : hasConfiguredRegistrationOptions(field) ? graphql/* FormInputType.Dropdown */.Tx.Dropdown : graphql/* FormInputType.Text */.Tx.Text
        };
    });
};
const normalizeDiscounts = (discounts)=>{
    return (discounts !== null && discounts !== void 0 ? discounts : []).map((discount)=>{
        var ref;
        const type = (ref = discount === null || discount === void 0 ? void 0 : discount.type) !== null && ref !== void 0 ? ref : graphql/* DiscountType.Percentage */.Lb.Percentage;
        var ref1, ref2;
        return {
            ...discount,
            type,
            tickets: (ref1 = discount === null || discount === void 0 ? void 0 : discount.tickets) !== null && ref1 !== void 0 ? ref1 : [],
            ...type === graphql/* DiscountType.Percentage */.Lb.Percentage ? {
                percentage: (ref2 = discount === null || discount === void 0 ? void 0 : discount.percentage) !== null && ref2 !== void 0 ? ref2 : 0
            } : {}
        };
    });
};
const escapeJsonPointerSegment = (segment)=>segment.replace(/~/g, "~0").replace(/\//g, "~1");
const toJsonPointer = (segments)=>"/".concat(segments.map(escapeJsonPointerSegment).join("/"));
const parseJsonPointer = (path)=>{
    if (!path || path[0] !== "/") {
        throw new Error("Invalid JSON pointer path: ".concat(path));
    }
    return path.slice(1).split("/").map((segment)=>segment.replace(/~1/g, "/").replace(/~0/g, "~"));
};
const getPointerParent = (target, path)=>{
    const segments = parseJsonPointer(path);
    const key = segments.pop();
    if (!key) throw new Error("Invalid JSON pointer path: ".concat(path));
    const parent = segments.reduce((current, segment)=>{
        if (current === undefined || current === null) return undefined;
        return current[segment];
    }, target);
    return {
        parent,
        key
    };
};
const setPointerValue = (target, path, value)=>{
    const { parent , key  } = getPointerParent(target, path);
    if (parent === undefined || parent === null) {
        throw new Error("Cannot set missing JSON pointer path: ".concat(path));
    }
    parent[key] = value;
};
const removePointerValue = (target, path)=>{
    const { parent , key  } = getPointerParent(target, path);
    if (parent === undefined || parent === null) {
        throw new Error("Cannot remove missing JSON pointer path: ".concat(path));
    }
    delete parent[key];
};
const applyPatchOperationsToDraft = (latestEvent, operations)=>{
    const rebasedDraft = cloneJson(latestEvent);
    operations.filter((operation)=>operation.op !== "test").forEach((operation)=>{
        if (operation.op === "remove") {
            removePointerValue(rebasedDraft, operation.path);
        } else {
            setPointerValue(rebasedDraft, operation.path, cloneJson(operation.value));
        }
    });
    return rebasedDraft;
};
const buildPatchOperations = function(baseValue, draftValue) {
    let path = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    const cleanBase = canonicalizePatchValue(baseValue);
    const cleanDraft = canonicalizePatchValue(draftValue);
    if ((0,lodash.isEqual)(cleanBase, cleanDraft)) return [];
    if (path.length > 0 && isPlainObject(cleanBase) && isPlainObject(cleanDraft)) {
        return Array.from(new Set([
            ...Object.keys(cleanBase),
            ...Object.keys(cleanDraft)
        ])).flatMap((key)=>buildPatchOperations(cleanBase[key], cleanDraft[key], [
                ...path,
                key
            ]));
    }
    if (path.length === 0) {
        return Array.from(new Set([
            ...Object.keys(cleanBase !== null && cleanBase !== void 0 ? cleanBase : {}),
            ...Object.keys(cleanDraft !== null && cleanDraft !== void 0 ? cleanDraft : {})
        ])).flatMap((key)=>{
            return buildPatchOperations(cleanBase === null || cleanBase === void 0 ? void 0 : cleanBase[key], cleanDraft === null || cleanDraft === void 0 ? void 0 : cleanDraft[key], [
                key
            ]);
        });
    }
    const pointer = toJsonPointer(path);
    const operation = {
        op: cleanDraft === undefined ? "remove" : cleanBase === undefined ? "add" : "replace",
        path: pointer
    };
    if (cleanDraft !== undefined) operation.value = cloneJson(cleanDraft);
    return [
        {
            op: "test",
            path: pointer,
            value: cloneJson(cleanBase)
        },
        operation
    ];
};
const buildEditableEventPayload = function(input, profile) {
    let fundraiserDefaults = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        startDateTime: moment_default()().toISOString(),
        registrationCloseDateTime: moment_default()().add(14, "d").toISOString(),
        endDateTime: moment_default()().add(1, "M").toISOString()
    };
    var ref;
    let event = {
        ...(ref = input === null || input === void 0 ? void 0 : input.event) !== null && ref !== void 0 ? ref : {}
    };
    let { organizationName  } = event;
    if (!organizationName || organizationName === "Unknown" || organizationName === "Default Event Organization") {
        var ref1, ref2, ref3;
        organizationName = (ref3 = (ref2 = (ref1 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref1 !== void 0 ? ref1 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref2 !== void 0 ? ref2 : profile === null || profile === void 0 ? void 0 : profile.fullName) !== null && ref3 !== void 0 ? ref3 : "Default Event Organization";
    }
    if (organizationName) event.organizationName = organizationName;
    if ((event === null || event === void 0 ? void 0 : event.eventType) === graphql/* EventType.Fundraiser */.tw.Fundraiser) {
        var ref4, ref5, ref6;
        event = {
            ...event,
            startDateTime: (ref4 = event === null || event === void 0 ? void 0 : event.startDateTime) !== null && ref4 !== void 0 ? ref4 : fundraiserDefaults.startDateTime,
            registrationCloseDateTime: (ref5 = event === null || event === void 0 ? void 0 : event.registrationCloseDateTime) !== null && ref5 !== void 0 ? ref5 : fundraiserDefaults.registrationCloseDateTime,
            endDateTime: (ref6 = event === null || event === void 0 ? void 0 : event.endDateTime) !== null && ref6 !== void 0 ? ref6 : fundraiserDefaults.endDateTime
        };
    }
    if (typeof event.eventLocationMapUrl === "string") {
        event.eventLocationMapUrl = event.eventLocationMapUrl.trim();
    }
    if (typeof event.eventLocationMapLink === "string") {
        event.eventLocationMapLink = event.eventLocationMapLink.trim();
    }
    var ref7;
    event = {
        ...event,
        publiclyListed: (ref7 = event === null || event === void 0 ? void 0 : event.publiclyListed) !== null && ref7 !== void 0 ? ref7 : true
    };
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    return canonicalizePatchValue({
        isPublished: input === null || input === void 0 ? void 0 : input.isPublished,
        isPremium: input === null || input === void 0 ? void 0 : input.isPremium,
        paymentProcessor: input === null || input === void 0 ? void 0 : input.paymentProcessor,
        event,
        discounts: normalizeDiscounts(input === null || input === void 0 ? void 0 : input.discounts),
        attendees: (ref8 = input === null || input === void 0 ? void 0 : input.attendees) !== null && ref8 !== void 0 ? ref8 : [],
        tickets: (ref9 = input === null || input === void 0 ? void 0 : input.tickets) !== null && ref9 !== void 0 ? ref9 : [],
        registrationFields: normalizeRegistrationFields(input === null || input === void 0 ? void 0 : input.registrationFields),
        speakers: (ref10 = input === null || input === void 0 ? void 0 : input.speakers) !== null && ref10 !== void 0 ? ref10 : [],
        stages: (ref11 = input === null || input === void 0 ? void 0 : input.stages) !== null && ref11 !== void 0 ? ref11 : [],
        sessions: (ref12 = input === null || input === void 0 ? void 0 : input.sessions) !== null && ref12 !== void 0 ? ref12 : [],
        sponsors: (ref13 = input === null || input === void 0 ? void 0 : input.sponsors) !== null && ref13 !== void 0 ? ref13 : [],
        ondemandContent: (ref14 = input === null || input === void 0 ? void 0 : input.ondemandContent) !== null && ref14 !== void 0 ? ref14 : [],
        communications: (ref15 = input === null || input === void 0 ? void 0 : input.communications) !== null && ref15 !== void 0 ? ref15 : {},
        notifications: (ref16 = input === null || input === void 0 ? void 0 : input.notifications) !== null && ref16 !== void 0 ? ref16 : [],
        emailTemplates: (ref17 = input === null || input === void 0 ? void 0 : input.emailTemplates) !== null && ref17 !== void 0 ? ref17 : [],
        breakoutRooms: (ref18 = input === null || input === void 0 ? void 0 : input.breakoutRooms) !== null && ref18 !== void 0 ? ref18 : [],
        fundraising: {
            ...(ref19 = input === null || input === void 0 ? void 0 : input.fundraising) !== null && ref19 !== void 0 ? ref19 : {}
        },
        notifyOrganiser: (ref20 = input === null || input === void 0 ? void 0 : input.notifyOrganiser) !== null && ref20 !== void 0 ? ref20 : false
    });
};
const getAttendeeIdentity = (attendee)=>{
    const normalize = (value)=>typeof value === "string" ? value.trim().toLowerCase() : undefined;
    const ticketCode = normalize(attendee === null || attendee === void 0 ? void 0 : attendee.ticketCode);
    const orderId = normalize(attendee === null || attendee === void 0 ? void 0 : attendee.orderId);
    const email = normalize(attendee === null || attendee === void 0 ? void 0 : attendee.email);
    const ticketTitle = normalize(attendee === null || attendee === void 0 ? void 0 : attendee.ticketTitle);
    const userId = normalize(attendee === null || attendee === void 0 ? void 0 : attendee.userId);
    if (ticketCode) return "ticket:".concat(ticketCode);
    if (orderId && email && ticketTitle) return "order:".concat(orderId, ":").concat(email, ":").concat(ticketTitle);
    if (userId && email) return "user:".concat(userId, ":").concat(email);
    if (email && ticketTitle) return "manual:".concat(email, ":").concat(ticketTitle);
    return undefined;
};
const buildAttendeeMap = function() {
    let attendees = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const result = new Map();
    for (const attendee of attendees){
        const identity = getAttendeeIdentity(attendee);
        if (!identity) {
            return {
                success: false,
                message: "An attendee has no stable identity and cannot be reapplied."
            };
        }
        if (result.has(identity)) {
            return {
                success: false,
                message: "Duplicate attendees cannot be reapplied automatically."
            };
        }
        result.set(identity, canonicalizePatchValue(attendee));
    }
    return {
        success: true,
        attendees: result
    };
};
const rebaseAttendeeChanges = (param)=>{
    let { baseAttendees =[] , draftAttendees =[] , latestAttendees =[]  } = param;
    var ref;
    const cleanBase = (ref = canonicalizePatchValue(baseAttendees)) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const cleanDraft = (ref1 = canonicalizePatchValue(draftAttendees)) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    const cleanLatest = (ref2 = canonicalizePatchValue(latestAttendees)) !== null && ref2 !== void 0 ? ref2 : [];
    const baseResult = buildAttendeeMap(cleanBase);
    const draftResult = buildAttendeeMap(cleanDraft);
    const latestResult = buildAttendeeMap(cleanLatest);
    if (!baseResult.success) return baseResult;
    if (!draftResult.success) return draftResult;
    if (!latestResult.success) return latestResult;
    const baseMap = baseResult.attendees;
    const draftMap = draftResult.attendees;
    const latestMap = latestResult.attendees;
    const removedKeys = Array.from(baseMap.keys()).filter((key)=>!draftMap.has(key));
    const changedEntries = Array.from(draftMap.entries()).filter((param)=>{
        let [key, attendee] = param;
        return !(0,lodash.isEqual)(baseMap.get(key), attendee);
    });
    if (removedKeys.length === 0 && changedEntries.length === 0) {
        return {
            success: false,
            message: "No attendee changes were available to reapply."
        };
    }
    for (const key of removedKeys){
        if (!latestMap.has(key)) continue;
        if (!(0,lodash.isEqual)(latestMap.get(key), baseMap.get(key))) {
            return {
                success: false,
                message: "An attendee you removed changed elsewhere."
            };
        }
        latestMap.delete(key);
    }
    for (const [key1, draftAttendee] of changedEntries){
        const baseAttendee = baseMap.get(key1);
        const latestAttendee = latestMap.get(key1);
        if (!baseAttendee) {
            if (latestAttendee && !(0,lodash.isEqual)(latestAttendee, draftAttendee)) {
                return {
                    success: false,
                    message: "An attendee you added already exists with different data."
                };
            }
            latestMap.set(key1, draftAttendee);
            continue;
        }
        if (!latestAttendee) {
            return {
                success: false,
                message: "An attendee you edited was removed elsewhere."
            };
        }
        if (!(0,lodash.isEqual)(latestAttendee, baseAttendee)) {
            return {
                success: false,
                message: "An attendee you edited changed elsewhere."
            };
        }
        latestMap.set(key1, draftAttendee);
    }
    return {
        success: true,
        attendees: Array.from(latestMap.values()),
        removedCount: removedKeys.length,
        changedCount: changedEntries.length
    };
};

;// CONCATENATED MODULE: ./libs/CreateEvent/useEventEditor.tsx




























const CREATE_EVENT_STAGE_EVENTS = {
    [CreateEventStage/* CreateEventStage.Type */.M.Type]: "create_event_step_1",
    [CreateEventStage/* CreateEventStage.Details */.M.Details]: "create_event_step_2",
    [CreateEventStage/* CreateEventStage.Communications */.M.Communications]: "create_event_step_3"
};
const getFormStateFromEventData = (_event)=>({
        details: true,
        registration: false,
        fundraising: false,
        speakers: false,
        stages: false,
        sessions: false,
        attendees: false,
        sponsors: false,
        onDemand: false,
        communications: false,
        breakoutRooms: false,
        notifications: false,
        emailTemplates: false
    });
const useEventEditorState = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const { publish , getEvent: getBlacBaudEvent  } = (0,useBlackBaud/* useBlackBaud */.M)();
    const [blackbaudId, setBlackbaudId] = (0,react.useState)();
    const [showBlackBaudModal, setShowBlackBaudModal] = (0,react.useState)(false);
    const [duplicateLoading, setDuplicateLoading] = (0,react.useState)(false);
    const [blackBaudComparison, setBlackBaudComparison] = (0,react.useState)({
        local: null,
        remote: null
    });
    const [baseEvent, setBaseEvent] = (0,react.useState)();
    const baseEventRef = (0,react.useRef)();
    const [formData, setFormData] = (0,react.useState)();
    const formDataRef = (0,react.useRef)();
    const hydratedEventResultRef = (0,react.useRef)();
    const saveInFlightRef = (0,react.useRef)(null);
    const saveRequestedRef = (0,react.useRef)(false);
    const requestedDraftRef = (0,react.useRef)();
    const saveGenerationRef = (0,react.useRef)(0);
    const activeSaveEventIdRef = (0,react.useRef)();
    const applyAttendeeConflictRef = (0,react.useRef)();
    const pendingAttendeeConflictRef = (0,react.useRef)();
    const [validationRules, setValidationRules] = (0,react.useState)([]);
    const [errors, setErrors] = (0,react.useState)([]);
    const [showEmbedModal, setShowEmbedModal] = (0,react.useState)(false);
    const [embedCopied, setEmbedCopied] = (0,react.useState)(false);
    const [showPublishConfirmation, setShowPublishConfirmation] = (0,react.useState)(false);
    const [showStripeRequiredModal, setShowStripeRequiredModal] = (0,react.useState)(false);
    const [usersMetadata, setUsersData] = (0,react.useState)([]);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [pushedToBlackbaud, setPushedToBlackbaud] = (0,react.useState)(false);
    const [loadingBlackBaud, setLoadingBlackBaud] = (0,react.useState)(false);
    const [blackBaudError, setBlackbaudError] = (0,react.useState)(false);
    const [createEventStage, dispatchCreateEventStage] = (0,react.useState)({
        stage: CreateEventStage/* CreateEventStage.Type */.M.Type,
        skipPreview: true
    });
    const [completeSections, setCompleteSections] = (0,react.useState)({
        details: false,
        registration: false,
        speakers: false,
        fundraising: false,
        stages: false,
        sessions: false,
        attendees: false,
        sponsors: false,
        onDemand: false,
        communications: false,
        breakoutRooms: false,
        notifications: false,
        emailTemplates: false
    });
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isZapierSyncing, setIsZapierSyncing] = (0,react.useState)(false);
    const [zapierSyncMessage, setZapierSyncMessage] = (0,react.useState)();
    const [showErrorModal, setShowErrorModal] = (0,react.useState)(false);
    const [saved, setSaved] = (0,react.useState)(false);
    const [eventTypeError, setEventTypeError] = (0,react.useState)();
    const eventTypeSelectionInProgressRef = (0,react.useRef)(false);
    const isNewEventFlowRef = (0,react.useRef)();
    const trackedCreateEventsRef = (0,react.useRef)(new Set());
    const { profile , getPermission , isOrganizer , isAdmin  } = (0,useAuth/* useAuth */.aC)();
    var ref8;
    const { profile: organisationProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)((ref8 = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref8 !== void 0 ? ref8 : profile === null || profile === void 0 ? void 0 : profile.university);
    const router = (0,next_router.useRouter)();
    const { query , push , isReady  } = router;
    var _id;
    const eventId = (0,react.useMemo)(()=>{
        return (_id = query.id) !== null && _id !== void 0 ? _id : formData === null || formData === void 0 ? void 0 : formData.eventId;
    }, [
        query.id,
        formData === null || formData === void 0 ? void 0 : formData.eventId
    ]);
    const urlEventId = (0,react.useMemo)(()=>{
        if (false) {}
        var ref;
        return (ref = new URLSearchParams(window.location.search).get("id")) !== null && ref !== void 0 ? ref : undefined;
    }, [
        router.asPath
    ]);
    var ref9, ref10;
    const activeEventId = (ref10 = (ref9 = formData === null || formData === void 0 ? void 0 : formData.eventId) !== null && ref9 !== void 0 ? ref9 : urlEventId) !== null && ref10 !== void 0 ? ref10 : router.query.id;
    const [isFirstLogin, setFirstLoginFlag] = (0,useLocalStorage/* default */.Z)("Forumm_FirstLogin", false);
    const { data: paymentSettingsData , loading: paymentSettingsLoading  } = (0,useQuery/* useQuery */.a)(payment_paymentSettings/* GET_PAYMENT_SETTINGS */.QF, {
        skip: !(profile === null || profile === void 0 ? void 0 : profile.userId)
    });
    const paymentSettings = paymentSettingsData === null || paymentSettingsData === void 0 ? void 0 : paymentSettingsData.getPaymentSettings;
    const hasDirtyChanges = (0,react.useMemo)(()=>{
        if (!baseEvent || !formData) return false;
        const fundraiserDefaults = {
            startDateTime: moment_default()().toISOString(),
            registrationCloseDateTime: moment_default()().add(14, "d").toISOString(),
            endDateTime: moment_default()().add(1, "M").toISOString()
        };
        return !(0,lodash.isEqual)(buildEditableEventPayload(baseEvent, profile, fundraiserDefaults), buildEditableEventPayload(formData, profile, fundraiserDefaults));
    }, [
        baseEvent,
        formData,
        profile
    ]);
    const [getEventById, { data , loading , refetch  }] = (0,useLazyQuery/* useLazyQuery */.t)(GET_EVENT_BY_ID_FOR_EDITOR, {
        fetchPolicy: "network-only"
    });
    const [getAttendeeMetadata] = (0,useLazyQuery/* useLazyQuery */.t)(GetUsersByIds/* GET_USERS_BY_IDS */.B);
    const [createEvent] = (0,useMutation/* useMutation */.D)(events_createEvent/* CREATE_EVENT */.G);
    const [applyEventPatch] = (0,useMutation/* useMutation */.D)(APPLY_EVENT_PATCH);
    const [syncEventAttendeesWithZapier] = (0,useMutation/* useMutation */.D)(SYNC_EVENT_ATTENDEES_WITH_ZAPIER);
    const [deleteEventById] = (0,useMutation/* useMutation */.D)(DELETE_EVENT_BY_ID);
    const [duplicateEventById] = (0,useMutation/* useMutation */.D)(DUPLICATE_EVENT_BY_ID);
    const setCreateEventStage = (0,react.useCallback)((data)=>{
        dispatchCreateEventStage((current)=>({
                ...current,
                ...data
            }));
    }, []);
    const trackCreateEvent = (0,react.useCallback)((eventName)=>{
        if (trackedCreateEventsRef.current.has(eventName)) return;
        (0,GoogleTags/* pushDataLayerEvent */.Jt)(eventName);
        trackedCreateEventsRef.current.add(eventName);
    }, []);
    const trackNewCreateEvent = (0,react.useCallback)((eventName)=>{
        if (!isNewEventFlowRef.current) return;
        trackCreateEvent(eventName);
    }, [
        trackCreateEvent
    ]);
    (0,react.useEffect)(()=>{
        if (!isReady || isNewEventFlowRef.current !== undefined) return;
        isNewEventFlowRef.current = query.id == null;
    }, [
        isReady,
        query.id
    ]);
    (0,react.useEffect)(()=>{
        if (!isReady || !(profile === null || profile === void 0 ? void 0 : profile.userId) || !isNewEventFlowRef.current) return;
        const stageEvent = CREATE_EVENT_STAGE_EVENTS[createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage];
        if (stageEvent) trackNewCreateEvent(stageEvent);
    }, [
        createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage,
        isReady,
        profile === null || profile === void 0 ? void 0 : profile.userId,
        trackNewCreateEvent
    ]);
    (0,react.useEffect)(()=>{
        if (isFirstLogin) setFirstLoginFlag(false);
    }, [
        isFirstLogin,
        setFirstLoginFlag
    ]);
    (0,react.useEffect)(()=>{
        baseEventRef.current = baseEvent;
    }, [
        baseEvent
    ]);
    (0,react.useEffect)(()=>{
        formDataRef.current = formData;
    }, [
        formData
    ]);
    (0,react.useEffect)(()=>{
        if (saved) {
            setTimeout(()=>{
                setSaved(false);
            }, 30000);
        }
    }, [
        saved
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (formData && ((ref = formData === null || formData === void 0 ? void 0 : formData.attendees) !== null && ref !== void 0 ? ref : []).length > 0) {
            var ref1, _userId;
            const userIds = ((ref1 = formData === null || formData === void 0 ? void 0 : formData.attendees) !== null && ref1 !== void 0 ? ref1 : []).filter((attendee)=>!!attendee.userId || !!attendee.email).map((attendee)=>(_userId = attendee.userId) !== null && _userId !== void 0 ? _userId : attendee.email).filter((id)=>Boolean(id));
            var _items;
            if (usersMetadata.length === 0) getAttendeeMetadata({
                variables: {
                    input: {
                        userIds
                    }
                },
                onCompleted: (data)=>setUsersData((_items = data.getUsersByIds.items) !== null && _items !== void 0 ? _items : [])
            });
        }
    }, [
        formData === null || formData === void 0 ? void 0 : formData.attendees
    ]);
    (0,react.useEffect)(()=>{
        console.log({
            isOrganizer
        });
        if (!!profile && !isOrganizer && !isAdmin) {
            setCreateEventStage({
                stage: CreateEventStage/* CreateEventStage.Space */.M.Space
            });
        }
        if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Space */.M.Space && isOrganizer) {
            setCreateEventStage({
                stage: CreateEventStage/* CreateEventStage.Type */.M.Type
            });
        }
    }, [
        profile
    ]);
    (0,react.useEffect)(()=>{
        console.log({
            eventId
        });
    }, [
        eventId
    ]);
    (0,react.useEffect)(()=>{
        if (pushedToBlackbaud) {
            (0,dist/* toast */.Am)("Successfully Synced with BlackBaud!", {
                icon: "\uD83C\uDF89",
                duration: 4000,
                className: "custom-toast"
            });
        }
    }, [
        pushedToBlackbaud
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        if (data === null || data === void 0 ? void 0 : (ref = data.getEventById) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.blackbaudId) setBlackbaudId(data === null || data === void 0 ? void 0 : (ref2 = data.getEventById) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.blackbaudId);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.getEventById) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.blackbaudId
    ]);
    (0,react.useEffect)(()=>{
        async function getEvent(eventId) {
            if (eventId && (isAdmin || isOrganizer)) {
                getEventById({
                    variables: {
                        input: {
                            eventId: eventId
                        }
                    }
                });
            }
        }
        if (isReady && eventId && (!loaded || (formData === null || formData === void 0 ? void 0 : formData.eventId) !== eventId)) {
            void getEvent(eventId);
        }
    }, [
        eventId,
        formData === null || formData === void 0 ? void 0 : formData.eventId,
        getEventById,
        isAdmin,
        isOrganizer,
        isReady,
        loaded
    ]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.getEventById) {
            var ref;
            if (hydratedEventResultRef.current === data.getEventById) return;
            hydratedEventResultRef.current = data.getEventById;
            const cleanPayload = (0,util/* cleanEventPayload */.O9)(data);
            const isDifferentEvent = (formData === null || formData === void 0 ? void 0 : formData.eventId) !== cleanPayload.eventId;
            const shouldHydrateCleanPayload = !formData || isDifferentEvent || !hasDirtyChanges && !(0,lodash.isEqual)(canonicalizePatchValue(formData), canonicalizePatchValue(cleanPayload));
            if (isReady && !loaded && (cleanPayload === null || cleanPayload === void 0 ? void 0 : (ref = cleanPayload.event) === null || ref === void 0 ? void 0 : ref.eventType)) {
                setCreateEventStage({
                    stage: CreateEventStage/* CreateEventStage.Details */.M.Details
                });
            }
            if (shouldHydrateCleanPayload) {
                if (isDifferentEvent) {
                    saveGenerationRef.current += 1;
                    activeSaveEventIdRef.current = cleanPayload.eventId;
                    saveRequestedRef.current = false;
                    requestedDraftRef.current = undefined;
                    saveInFlightRef.current = null;
                }
                baseEventRef.current = cleanPayload;
                formDataRef.current = cleanPayload;
                setBaseEvent(cleanPayload);
                setFormData(cleanPayload);
                setLoaded(true);
            }
        }
        if (isReady && eventId == null) {
            setLoaded(true);
        }
    }, [
        data,
        eventId,
        formData,
        hasDirtyChanges,
        isReady,
        loaded
    ]);
    const disableProgress = (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Type */.M.Type && !!!(formData === null || formData === void 0 ? void 0 : (ref2 = formData.event) === null || ref2 === void 0 ? void 0 : ref2.eventType);
    const items = (0,react.useMemo)(()=>{
        return [
            {
                label: "Type",
                targetStage: CreateEventStage/* CreateEventStage.Type */.M.Type
            },
            {
                label: "Details",
                targetStage: CreateEventStage/* CreateEventStage.Details */.M.Details
            },
            {
                label: "Communication",
                targetStage: CreateEventStage/* CreateEventStage.Communications */.M.Communications
            },
            {
                label: "Preview",
                targetStage: CreateEventStage/* CreateEventStage.Preview */.M.Preview
            }
        ].filter((item)=>{
            var ref;
            return item.targetStage === CreateEventStage/* CreateEventStage.Communications */.M.Communications && (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) !== graphql/* EventType.Fundraiser */.tw.Fundraiser || item.targetStage !== CreateEventStage/* CreateEventStage.Communications */.M.Communications;
        });
    }, [
        formData === null || formData === void 0 ? void 0 : (ref3 = formData.event) === null || ref3 === void 0 ? void 0 : ref3.eventType
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        var ref1;
        const rules = (0,validation/* getValidationRules */.sl)((ref1 = formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) !== null && ref1 !== void 0 ? ref1 : undefined).reduce((acc, val)=>acc.find((rule)=>rule[0] === val[0] || typeof val[1] === "function") ? acc : [
                ...acc,
                val
            ], []);
        setValidationRules(rules);
    }, [
        formData === null || formData === void 0 ? void 0 : (ref4 = formData.event) === null || ref4 === void 0 ? void 0 : ref4.eventType
    ]);
    const generateEventId = async (eventType)=>{
        var ref, ref1, ref2;
        const initialDateTime = moment_default()();
        const startDateTime = initialDateTime.clone().add(1, "d").toISOString();
        const endDateTime = initialDateTime.clone().add(5, "d").toISOString();
        var ref3, ref4;
        const payload = {
            event: {
                title: "",
                shortDescription: "",
                description: "",
                startDateTime,
                entryDateTime: startDateTime,
                endDateTime,
                registrationCloseDateTime: startDateTime,
                organizationName: (ref4 = (ref3 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref3 !== void 0 ? ref3 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref4 !== void 0 ? ref4 : "",
                publiclyListed: true,
                eventType: eventType !== null && eventType !== void 0 ? eventType : graphql/* EventType.Online */.tw.Online
            }
        };
        const createdEvent = await createEvent({
            variables: {
                input: payload
            }
        });
        const createdEventId = (ref = createdEvent.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createEvent) === null || ref1 === void 0 ? void 0 : ref1.eventId;
        if (!createdEventId) return undefined;
        const createdEventResponse = await getEventById({
            variables: {
                input: {
                    eventId: createdEventId
                }
            }
        });
        const persistedCreatedEvent = ((ref2 = createdEventResponse.data) === null || ref2 === void 0 ? void 0 : ref2.getEventById) ? (0,util/* cleanEventPayload */.O9)(createdEventResponse.data) : undefined;
        const createdFormData = persistedCreatedEvent ? {
            ...persistedCreatedEvent,
            event: {
                ...persistedCreatedEvent.event,
                title: payload.event.title || undefined,
                startDateTime: payload.event.startDateTime,
                entryDateTime: payload.event.entryDateTime,
                endDateTime: payload.event.endDateTime,
                registrationCloseDateTime: payload.event.registrationCloseDateTime
            }
        } : undefined;
        if (createdFormData) {
            var ref5;
            hydratedEventResultRef.current = (ref5 = createdEventResponse.data) === null || ref5 === void 0 ? void 0 : ref5.getEventById;
            saveGenerationRef.current += 1;
            saveRequestedRef.current = false;
            requestedDraftRef.current = undefined;
            saveInFlightRef.current = null;
            baseEventRef.current = createdFormData;
            formDataRef.current = createdFormData;
            activeSaveEventIdRef.current = createdFormData.eventId;
            setBaseEvent(createdFormData);
            setFormData(createdFormData);
        }
        window.history.replaceState("", "Create Event", "?id=".concat(createdEventId));
        return createdFormData;
    };
    const formState = getFormStateFromEventData(formData);
    const runPatchSave = (0,react.useCallback)(async (draft)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var _eventId, ref7;
        const eventId = (ref7 = (_eventId = draft.eventId) !== null && _eventId !== void 0 ? _eventId : urlEventId) !== null && ref7 !== void 0 ? ref7 : router.query.id;
        const currentBaseEvent = baseEventRef.current;
        const saveGeneration = saveGenerationRef.current;
        if (!eventId || !currentBaseEvent) return undefined;
        if (activeSaveEventIdRef.current && activeSaveEventIdRef.current !== eventId) {
            return undefined;
        }
        activeSaveEventIdRef.current = eventId;
        const fundraiserDefaults = {
            startDateTime: moment_default()().toISOString(),
            registrationCloseDateTime: moment_default()().add(14, "d").toISOString(),
            endDateTime: moment_default()().add(1, "M").toISOString()
        };
        const basePayload = buildEditableEventPayload(currentBaseEvent, profile, fundraiserDefaults);
        const draftPayload = buildEditableEventPayload({
            ...draft,
            eventId
        }, profile, fundraiserDefaults);
        const isCroppingBanner = typeof (draftPayload === null || draftPayload === void 0 ? void 0 : (ref = draftPayload.event) === null || ref === void 0 ? void 0 : ref.bannerImage) !== "string" && !!(draftPayload === null || draftPayload === void 0 ? void 0 : (ref1 = draftPayload.event) === null || ref1 === void 0 ? void 0 : ref1.bannerImage);
        const isCroppingThumb = typeof (draftPayload === null || draftPayload === void 0 ? void 0 : (ref2 = draftPayload.event) === null || ref2 === void 0 ? void 0 : ref2.thumbnailImage) !== "string" && !!(draftPayload === null || draftPayload === void 0 ? void 0 : (ref3 = draftPayload.event) === null || ref3 === void 0 ? void 0 : ref3.thumbnailImage);
        const updateException = isCroppingBanner || isCroppingThumb;
        const operations = buildPatchOperations(basePayload, draftPayload);
        if (updateException || operations.length < 1 || !(draftPayload === null || draftPayload === void 0 ? void 0 : (ref4 = draftPayload.event) === null || ref4 === void 0 ? void 0 : ref4.title) || (draftPayload === null || draftPayload === void 0 ? void 0 : (ref5 = draftPayload.event) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.title) === null || ref6 === void 0 ? void 0 : ref6.length) < 1 || !isAdmin && !isOrganizer) {
            return eventId;
        }
        setIsLoading(true);
        try {
            var ref8, ref9;
            const response = await applyEventPatch({
                variables: {
                    input: {
                        eventId,
                        operations
                    }
                }
            });
            const result = (ref8 = response.data) === null || ref8 === void 0 ? void 0 : ref8.applyEventPatch;
            if (saveGeneration !== saveGenerationRef.current || activeSaveEventIdRef.current !== eventId) {
                return undefined;
            }
            if (!(result === null || result === void 0 ? void 0 : result.success)) {
                setSaved(false);
                var ref10;
                const conflicts = (ref10 = result === null || result === void 0 ? void 0 : result.conflicts) !== null && ref10 !== void 0 ? ref10 : [];
                const hasOnlyAttendeeConflicts = conflicts.length > 0 && conflicts.every((conflict)=>conflict.path === "/attendees");
                const hasAttendeePatch = operations.some((operation)=>operation.op !== "test" && operation.path === "/attendees");
                if (hasOnlyAttendeeConflicts && hasAttendeePatch) {
                    pendingAttendeeConflictRef.current = {
                        eventId,
                        basePayload
                    };
                    dist/* toast.custom */.Am.custom((toastInstance)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(toastInstance.visible ? "animate-enter" : "animate-leave", " max-w-md rounded-md border border-gray-200 bg-white p-4 text-sm text-gray-900 shadow-lg"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-medium",
                                    children: "Attendees changed while editing."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-1 text-gray-600",
                                    children: "Apply your attendee change to the latest attendee list?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-3 flex justify-end gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "rounded border border-gray-300 px-3 py-1 text-xs",
                                            onClick: ()=>dist/* toast.dismiss */.Am.dismiss(toastInstance.id),
                                            children: "Dismiss"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "rounded bg-black px-3 py-1 text-xs text-white",
                                            onClick: ()=>{
                                                var ref;
                                                dist/* toast.dismiss */.Am.dismiss(toastInstance.id);
                                                void ((ref = applyAttendeeConflictRef.current) === null || ref === void 0 ? void 0 : ref.call(applyAttendeeConflictRef));
                                            },
                                            children: "Apply to latest"
                                        })
                                    ]
                                })
                            ]
                        });
                    }, {
                        duration: 15000
                    });
                    return undefined;
                }
                dist/* toast.error */.Am.error("This event changed elsewhere. Your draft has not been overwritten.");
                return undefined;
            }
            const savedEvent = result.event ? (0,util/* cleanGqlPayload */.GR)(result.event) : cloneJson({
                ...draft,
                eventId
            });
            const latestFormData = formDataRef.current;
            const savedDraft = cloneJson({
                ...draft,
                eventId
            });
            if (savedEvent) {
                baseEventRef.current = savedEvent;
                setBaseEvent(savedEvent);
                const localOperations = buildPatchOperations(buildEditableEventPayload(savedDraft, profile, fundraiserDefaults), buildEditableEventPayload(latestFormData, profile, fundraiserDefaults));
                if (!latestFormData || localOperations.length === 0) {
                    formDataRef.current = savedEvent;
                    setFormData(savedEvent);
                } else {
                    const savedPayload = buildEditableEventPayload(savedEvent, profile, fundraiserDefaults);
                    const rebasedPayload = applyPatchOperationsToDraft(savedPayload, localOperations);
                    const rebasedDraft = {
                        ...savedEvent,
                        ...rebasedPayload,
                        eventId
                    };
                    formDataRef.current = rebasedDraft;
                    requestedDraftRef.current = rebasedDraft;
                    saveRequestedRef.current = true;
                    setFormData(rebasedDraft);
                }
            }
            setSaved(!saveRequestedRef.current);
            var ref11;
            return (ref11 = (ref9 = result.event) === null || ref9 === void 0 ? void 0 : ref9.eventId) !== null && ref11 !== void 0 ? ref11 : eventId;
        } catch (error) {
            setSaved(false);
            dist/* toast.error */.Am.error("Unable to save this event. Your draft has been kept.");
            return undefined;
        } finally{
            setIsLoading(false);
        }
    }, [
        applyEventPatch,
        isAdmin,
        isOrganizer,
        profile,
        router.query.id,
        urlEventId
    ]);
    const saveChanges = (0,react.useCallback)((draft)=>{
        requestedDraftRef.current = cloneJson(draft);
        formDataRef.current = requestedDraftRef.current;
        saveRequestedRef.current = true;
        if (!saveInFlightRef.current) {
            const generation = saveGenerationRef.current;
            const saveLoop = (async ()=>{
                let savedEventId;
                while(saveRequestedRef.current && generation === saveGenerationRef.current){
                    saveRequestedRef.current = false;
                    var _current;
                    const nextDraft = (_current = requestedDraftRef.current) !== null && _current !== void 0 ? _current : formDataRef.current;
                    if (!nextDraft) break;
                    savedEventId = await runPatchSave(cloneJson(nextDraft));
                    if (!savedEventId) break;
                }
                return savedEventId;
            })();
            saveInFlightRef.current = saveLoop;
            void saveLoop.finally(()=>{
                if (saveInFlightRef.current === saveLoop) {
                    saveInFlightRef.current = null;
                }
            });
        }
        return saveInFlightRef.current;
    }, [
        runPatchSave
    ]);
    applyAttendeeConflictRef.current = async ()=>{
        const pendingConflict = pendingAttendeeConflictRef.current;
        const currentDraft = formDataRef.current;
        if (!pendingConflict || !currentDraft) return;
        setIsLoading(true);
        try {
            var ref;
            const latestResponse = await refetch({
                input: {
                    eventId: pendingConflict.eventId
                }
            });
            const latestEvent = (0,util/* cleanEventPayload */.O9)(latestResponse.data);
            if (!latestEvent) {
                dist/* toast.error */.Am.error("Unable to load latest attendees.");
                return;
            }
            const fundraiserDefaults = {
                startDateTime: moment_default()().toISOString(),
                registrationCloseDateTime: moment_default()().add(14, "d").toISOString(),
                endDateTime: moment_default()().add(1, "M").toISOString()
            };
            const currentPayload = buildEditableEventPayload(currentDraft, profile, fundraiserDefaults);
            var _attendees;
            const attendeeRebase = rebaseAttendeeChanges({
                baseAttendees: pendingConflict.basePayload.attendees,
                draftAttendees: currentPayload.attendees,
                latestAttendees: (_attendees = latestEvent.attendees) !== null && _attendees !== void 0 ? _attendees : []
            });
            if (!attendeeRebase.success) {
                dist/* toast.error */.Am.error(attendeeRebase.message);
                return;
            }
            const nonAttendeeOperations = buildPatchOperations(pendingConflict.basePayload, currentPayload).filter((operation)=>operation.path !== "/attendees");
            const latestPayload = buildEditableEventPayload(latestEvent, profile, fundraiserDefaults);
            const rebasedPayload = applyPatchOperationsToDraft(latestPayload, nonAttendeeOperations);
            const rebasedDraft = {
                ...latestEvent,
                ...rebasedPayload,
                eventId: pendingConflict.eventId,
                attendees: attendeeRebase.attendees
            };
            hydratedEventResultRef.current = (ref = latestResponse.data) === null || ref === void 0 ? void 0 : ref.getEventById;
            pendingAttendeeConflictRef.current = undefined;
            baseEventRef.current = latestEvent;
            formDataRef.current = rebasedDraft;
            setBaseEvent(latestEvent);
            setFormData(rebasedDraft);
            await saveChanges(rebasedDraft);
        } catch (error) {
            dist/* toast.error */.Am.error("Unable to apply attendee change.");
        } finally{
            setIsLoading(false);
        }
    };
    const handleNext = async (e)=>{
        var ref;
        const hasErrors = !!errors && (0,lodash.isArray)(errors) && (errors === null || errors === void 0 ? void 0 : errors.length) > 0;
        if (hasErrors || !formData) return null;
        saveChanges({
            ...formData
        });
        e.preventDefault();
        const { eventType  } = formData === null || formData === void 0 ? void 0 : formData.event;
        const pushToEvent = ()=>{
            return router.push("event/".concat(formData === null || formData === void 0 ? void 0 : formData.eventId).concat(eventType === graphql/* EventType.Fundraiser */.tw.Fundraiser ? "/donate" : ""));
        };
        let nextStage = CreateEventStage/* CreateEventStage.Details */.M.Details;
        if (!(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType)) nextStage = CreateEventStage/* CreateEventStage.Type */.M.Type;
        if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Type */.M.Type) nextStage = CreateEventStage/* CreateEventStage.Details */.M.Details;
        if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Details */.M.Details) if (eventType === graphql/* EventType.Fundraiser */.tw.Fundraiser) {
            if (createEventStage.skipPreview) pushToEvent();
            else nextStage = CreateEventStage/* CreateEventStage.Preview */.M.Preview;
        } else nextStage = CreateEventStage/* CreateEventStage.Communications */.M.Communications;
        if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Communications */.M.Communications) {
            if (createEventStage.skipPreview) pushToEvent();
            else nextStage = CreateEventStage/* CreateEventStage.Preview */.M.Preview;
        }
        if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Preview */.M.Preview) pushToEvent();
        setCreateEventStage({
            stage: nextStage
        });
    };
    const debouncedSave = (0,react.useCallback)((0,util/* debounce */.Ds)((input)=>{
        var ref;
        const hasErrors = !!(input === null || input === void 0 ? void 0 : input.errors) && (0,lodash.isArray)(input === null || input === void 0 ? void 0 : input.errors) && (input === null || input === void 0 ? void 0 : (ref = input.errors) === null || ref === void 0 ? void 0 : ref.length) > 0;
        if (!hasErrors && !!(input === null || input === void 0 ? void 0 : input.formData)) saveChanges({
            ...input.formData
        });
    }, 1000), [
        saveChanges
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        debouncedSave({
            formData,
            errors
        });
        const payload = {
            ...completeSections
        };
        if ((formData === null || formData === void 0 ? void 0 : formData.event) && (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) payload.details = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.tickets) && (formData === null || formData === void 0 ? void 0 : (ref2 = formData.tickets) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) payload.registration = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.speakers) && (formData === null || formData === void 0 ? void 0 : (ref3 = formData.speakers) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) payload.speakers = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.fundraising) && (formData === null || formData === void 0 ? void 0 : (ref4 = formData.fundraising) === null || ref4 === void 0 ? void 0 : ref4.goal)) payload.fundraising = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.stages) && (formData === null || formData === void 0 ? void 0 : (ref5 = formData.stages) === null || ref5 === void 0 ? void 0 : ref5.length) > 0) payload.stages = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.sessions) && formData.sessions.length > 0) payload.sessions = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.attendees) && formData.attendees.length > 0) payload.attendees = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.sponsors) && formData.sponsors.length > 0) payload.sponsors = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.breakoutRooms) && formData.breakoutRooms.length > 0) payload.breakoutRooms = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.ondemandContent) && formData.ondemandContent.length > 0) payload.onDemand = true;
        if ((formData === null || formData === void 0 ? void 0 : formData.notifications) && formData.notifications.length > 0) payload.notifications = true;
        setCompleteSections({
            ...completeSections,
            ...payload
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formData
    ]);
    const handleSelectEventType = async (eventType)=>{
        if (eventTypeSelectionInProgressRef.current) return;
        eventTypeSelectionInProgressRef.current = true;
        setIsLoading(true);
        setEventTypeError(undefined);
        try {
            let payload = {
                ...formData,
                event: {
                    ...formData === null || formData === void 0 ? void 0 : formData.event,
                    eventType
                }
            };
            if (!(formData === null || formData === void 0 ? void 0 : formData.eventId) && !urlEventId && !router.query.id) {
                const createdFormData = await generateEventId(eventType);
                if (!(createdFormData === null || createdFormData === void 0 ? void 0 : createdFormData.eventId)) {
                    throw new Error("Unable to start your event. Please try again.");
                }
                payload = {
                    ...createdFormData,
                    event: {
                        ...createdFormData.event,
                        eventType
                    }
                };
            }
            formDataRef.current = payload;
            setFormData(payload);
            setCreateEventStage({
                stage: CreateEventStage/* CreateEventStage.Details */.M.Details
            });
        } catch (error) {
            var ref;
            setEventTypeError((ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : "Unable to start your event. Please try again.");
        } finally{
            eventTypeSelectionInProgressRef.current = false;
            setIsLoading(false);
        }
    };
    const handleZapierAttendeeSync = async ()=>{
        var ref;
        const eventIdToSync = activeEventId;
        if (!eventIdToSync || !(formData === null || formData === void 0 ? void 0 : (ref = formData.attendees) === null || ref === void 0 ? void 0 : ref.length)) return;
        setIsZapierSyncing(true);
        setZapierSyncMessage(undefined);
        try {
            var ref1;
            const savedEventId = await saveChanges({
                ...formData
            });
            const response = await syncEventAttendeesWithZapier({
                variables: {
                    eventId: savedEventId !== null && savedEventId !== void 0 ? savedEventId : eventIdToSync
                }
            });
            const result = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.syncEventAttendeesWithZapier;
            if (!(result === null || result === void 0 ? void 0 : result.success)) {
                var ref2;
                throw new Error((ref2 = result === null || result === void 0 ? void 0 : result.error) !== null && ref2 !== void 0 ? ref2 : "Unable to sync attendees with Zapier");
            }
            setZapierSyncMessage("Queued ".concat(result.attendeesSynced, " attendees and ") + "".concat(result.attendanceUpdatesSynced, " attendance updates for Zapier sync."));
        } catch (error) {
            var ref3;
            setZapierSyncMessage((ref3 = error === null || error === void 0 ? void 0 : error.message) !== null && ref3 !== void 0 ? ref3 : "Unable to sync attendees with Zapier.");
        } finally{
            setIsZapierSyncing(false);
        }
    };
    const perms = getPermission("EVENT::TYPE::*");
    const toggleFundraising = (val)=>{
        return setFormData({
            ...formData,
            fundraising: {
                ...formData === null || formData === void 0 ? void 0 : formData.fundraising,
                enabled: val
            }
        });
    };
    const togglePremium = (val)=>{
        if (isAdmin || !!perms.find((p)=>p === "PREMIUM")) setFormData({
            ...formData,
            isPremium: val !== null && val !== void 0 ? val : formData === null || formData === void 0 ? void 0 : formData.isPremium
        });
    };
    const goToDetailsStage = ()=>setCreateEventStage({
            stage: CreateEventStage/* CreateEventStage.Details */.M.Details
        });
    const goToDashboard = ()=>router.push("/dashboard");
    const handlePushToCRM = async (selection, updatedConstituents)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        setLoadingBlackBaud(true);
        const response = await publish(eventId, selection, updatedConstituents, blackbaudId);
        const isSuccess = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.pushToBlackbaud) === null || ref1 === void 0 ? void 0 : ref1.success;
        if (response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pushToBlackbaud) === null || ref3 === void 0 ? void 0 : ref3.newBlackbaudId) setBlackbaudId(response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pushToBlackbaud) === null || ref5 === void 0 ? void 0 : ref5.newBlackbaudId);
        if (isSuccess) {
            setPushedToBlackbaud(true);
        } else {
            setBlackbaudError(true);
        }
        setTimeout(()=>{
            setPushedToBlackbaud(false);
            setLoadingBlackBaud(false);
        }, 1000);
    };
    const openBlackBaudModal = async ()=>{
        var ref, ref1, ref2;
        setBlackbaudError(false);
        setLoadingBlackBaud(true);
        const response = await getBlacBaudEvent(eventId, blackbaudId);
        if ((response === null || response === void 0 ? void 0 : (ref = response.errors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.message) === "AuthenticationError") {
            setBlackbaudError(true);
            setLoadingBlackBaud(false);
            return;
        }
        const localEvent = formData === null || formData === void 0 ? void 0 : formData.event;
        var ref3;
        const localAttendees = (ref3 = formData === null || formData === void 0 ? void 0 : formData.attendees) !== null && ref3 !== void 0 ? ref3 : [];
        var ref4;
        const localSpeakers = (ref4 = formData === null || formData === void 0 ? void 0 : formData.speakers) !== null && ref4 !== void 0 ? ref4 : [];
        const blackbaudEvent = response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.getBlackBaudEvent;
        let blackbaudData = null;
        var ref5, ref6;
        const localData = [
            {
                label: "Title",
                content: (ref5 = localEvent === null || localEvent === void 0 ? void 0 : localEvent.title) !== null && ref5 !== void 0 ? ref5 : ""
            },
            {
                label: "Description",
                content: (ref6 = localEvent === null || localEvent === void 0 ? void 0 : localEvent.shortDescription) !== null && ref6 !== void 0 ? ref6 : ""
            },
            {
                label: "Start Date",
                content: (localEvent === null || localEvent === void 0 ? void 0 : localEvent.startDateTime) ? (0,EventTime/* formatEventInstant */.g6)(localEvent === null || localEvent === void 0 ? void 0 : localEvent.startDateTime, "MMM DD, h:mmA", localEvent) : ""
            },
            {
                label: "End Date",
                content: (localEvent === null || localEvent === void 0 ? void 0 : localEvent.endDateTime) ? (0,EventTime/* formatEventInstant */.g6)(localEvent === null || localEvent === void 0 ? void 0 : localEvent.endDateTime, "MMM DD, h:mmA", localEvent) : ""
            },
            {
                label: "Attendees",
                content: localAttendees.map((attendee)=>"".concat(attendee.name, " (").concat(attendee.email, ")")).join(", "),
                metadata: usersMetadata || []
            },
            {
                label: "Speakers",
                content: localSpeakers.map((speaker)=>"".concat(speaker.name, " (").concat(speaker.email, ")")).join(", ")
            }
        ];
        if (blackbaudEvent) {
            var ref7, ref8;
            const startDateTime = "".concat((ref7 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.start_date) !== null && ref7 !== void 0 ? ref7 : "", " ").concat((ref8 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.start_time) !== null && ref8 !== void 0 ? ref8 : "");
            var ref9, ref10;
            const endDateTime = "".concat((ref9 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.end_date) !== null && ref9 !== void 0 ? ref9 : "", " ").concat((ref10 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.end_time) !== null && ref10 !== void 0 ? ref10 : "");
            var ref11, ref12;
            blackbaudData = [
                {
                    label: "Title",
                    content: (ref11 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.name) !== null && ref11 !== void 0 ? ref11 : ""
                },
                {
                    label: "Description",
                    content: (ref12 = blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.description) !== null && ref12 !== void 0 ? ref12 : ""
                },
                {
                    label: "Start Date",
                    content: startDateTime ? moment_default()(startDateTime).format("MMM DD, h:mmA") : null
                },
                {
                    label: "End Date",
                    content: endDateTime ? moment_default()(endDateTime).format("MMM DD, h:mmA") : null
                },
                {
                    label: "Attendees",
                    content: blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.attendees.map((attendee)=>"".concat(attendee.name, " (").concat(attendee.email, ")")).join(", "),
                    list: blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.attendees
                },
                {
                    label: "Speakers",
                    content: blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.speakers.map((speaker)=>"".concat(speaker.name, " (").concat(speaker.email, ")")).join(", "),
                    list: blackbaudEvent === null || blackbaudEvent === void 0 ? void 0 : blackbaudEvent.attendees
                }
            ];
        }
        setBlackBaudComparison({
            local: localData,
            remote: blackbaudData
        });
        setShowBlackBaudModal(true);
        setLoadingBlackBaud(false);
    };
    const handleSaveSelectionBlackBaud = async (selection, updatedConstituents)=>{
        setShowBlackBaudModal(false);
        setBlackbaudError(false);
        handlePushToCRM(selection, updatedConstituents);
    };
    const alreadyOnBlackbaud = blackbaudId || pushedToBlackbaud;
    var ref11;
    const hasPaidTickets = (0,react.useMemo)(()=>{
        return ((ref11 = formData === null || formData === void 0 ? void 0 : formData.tickets) !== null && ref11 !== void 0 ? ref11 : []).some((ticket)=>ticket.ticketType === graphql/* TicketType.Paid */.zK.Paid || ticket.ticketType === graphql/* TicketType.GroupGuest */.zK.GroupGuest);
    }, [
        formData === null || formData === void 0 ? void 0 : formData.tickets
    ]);
    var ref12;
    const configuredPaymentProcessor = (ref12 = formData === null || formData === void 0 ? void 0 : formData.paymentProcessor) !== null && ref12 !== void 0 ? ref12 : "STRIPE";
    const selectedPaymentProcessor = configuredPaymentProcessor === "GOCARDLESS" && !(0,paymentFeatureFlags/* isGoCardlessEnabled */.w)() ? "PAYMENTS_DISABLED" : configuredPaymentProcessor;
    var ref13;
    const paymentCurrency = ((ref13 = formData === null || formData === void 0 ? void 0 : (ref5 = formData.event) === null || ref5 === void 0 ? void 0 : ref5.currency) !== null && ref13 !== void 0 ? ref13 : "GBP").toUpperCase();
    const goCardlessCurrencySupported = [
        "GBP",
        "EUR"
    ].includes(paymentCurrency);
    const selectedPaymentConnection = selectedPaymentProcessor === "STRIPE" ? paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.stripe : selectedPaymentProcessor === "GOCARDLESS" ? paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.gocardless : undefined;
    const paymentSelectionReady = selectedPaymentProcessor !== "PAYMENTS_DISABLED" && !!(selectedPaymentConnection === null || selectedPaymentConnection === void 0 ? void 0 : selectedPaymentConnection.ready) && (selectedPaymentProcessor !== "GOCARDLESS" || goCardlessCurrencySupported);
    const paymentBlocksPublish = hasPaidTickets && !paymentSelectionReady;
    const eventActionsVisible = eventId && !!(data === null || data === void 0 ? void 0 : (ref6 = data.getEventById) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.event) === null || ref7 === void 0 ? void 0 : ref7.eventType) && !!(formData === null || formData === void 0 ? void 0 : formData.event);
    const embedBaseUrl =  false ? 0 : window.location.origin;
    const embedEventId = Array.isArray(eventId) ? eventId[0] : eventId;
    const embedContainerId = "forumm-registration-".concat(String(embedEventId !== null && embedEventId !== void 0 ? embedEventId : "").replace(/[^a-zA-Z0-9_-]/g, "-"));
    const embedCode = '<div id="'.concat(embedContainerId, '"></div>\n\n<script\n  src="').concat(embedBaseUrl, '/forumm-embed.js"\n  data-event-id="').concat(embedEventId !== null && embedEventId !== void 0 ? embedEventId : "", '"\n  data-container-id="').concat(embedContainerId, '"\n  data-height="760">\n</script>');
    const handleCopyEmbedCode = async ()=>{
        try {
            await navigator.clipboard.writeText(embedCode);
            setEmbedCopied(true);
            setTimeout(()=>setEmbedCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy embed code!", err);
        }
    };
    const handlePublishRequest = ()=>{
        var ref;
        if (formData === null || formData === void 0 ? void 0 : formData.isPublished) return;
        var ref1;
        const eventType = (ref1 = formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) !== null && ref1 !== void 0 ? ref1 : graphql/* EventType.Online */.tw.Online;
        const results = (0,validation/* validate */.Gu)({
            ...formData
        }, (0,validation/* getValidationRules */.sl)(eventType));
        if (results.error) {
            setErrors((state)=>[
                    ...state,
                    {
                        ...results.error,
                        alert: true
                    }
                ]);
            return;
        }
        if (paymentBlocksPublish) {
            setShowStripeRequiredModal(true);
            return;
        }
        setShowPublishConfirmation(true);
    };
    const handleConfirmPublish = async ()=>{
        if (!eventId || !isAdmin && !isOrganizer || !formData) return;
        const publishDraft = {
            ...formData,
            eventId: eventId,
            isPublished: true
        };
        formDataRef.current = publishDraft;
        setFormData(publishDraft);
        await saveChanges(publishDraft).then(async (savedEventId)=>{
            if (savedEventId) {
                trackCreateEvent("create_event_published");
                await refetch();
            }
        });
        setShowPublishConfirmation(false);
    };
    const handleGoToStripeSettings = ()=>{
        if (embedEventId) {
            window.localStorage.setItem("Forumm_LastEventEdited", embedEventId);
        }
        push("/organisation-settings?tab=payments");
    };
    const handleDuplicateEvent = async ()=>{
        setDuplicateLoading(true);
        await duplicateEventById({
            variables: {
                eventId: eventId
            }
        }).then((data)=>{
            var ref, ref1;
            const success = (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.duplicateEventById) === null || ref1 === void 0 ? void 0 : ref1.success;
            if (!!success && success === true) {
                var ref2, ref3;
                const eventId = (ref3 = data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.duplicateEventById.event) === null || ref3 === void 0 ? void 0 : ref3.eventId;
                setTimeout(async ()=>{
                    await push("/create-event?id=".concat(eventId)).then(()=>router.reload());
                }, 500);
                setDuplicateLoading(false);
            } else {
                (0,dist/* toast */.Am)("Unexpected Error when duplicating event.", {
                    icon: "!",
                    duration: 5000,
                    className: "custom-toast"
                });
            }
        }).finally(()=>setDuplicateLoading(false));
    };
    const handleDeleteEvent = ()=>{
        deleteEventById({
            variables: {
                input: {
                    eventId: eventId
                }
            }
        });
        setTimeout(()=>{
            push("/dashboard");
        }, 500);
    };
    return {
        activeEventId,
        alreadyOnBlackbaud,
        blackBaudComparison,
        blackBaudError,
        completeSections,
        createEventStage,
        disableProgress,
        duplicateLoading,
        embedCode,
        embedCopied,
        errors,
        eventTypeError,
        eventActionsVisible,
        eventId,
        formData,
        formState,
        goToDashboard,
        goToDetailsStage,
        handleConfirmPublish,
        handleCopyEmbedCode,
        handleDeleteEvent,
        handleDuplicateEvent,
        handleGoToStripeSettings,
        handleNext,
        handlePublishRequest,
        handleSaveSelectionBlackBaud,
        handleSelectEventType,
        handleZapierAttendeeSync,
        hasDirtyChanges,
        isAdmin,
        isFirstLogin,
        isLoading,
        isZapierSyncing,
        items,
        loading,
        loadingBlackBaud,
        goCardlessCurrencySupported,
        hasPaidTickets,
        openBlackBaudModal,
        organisationProfile,
        perms,
        profile,
        refetchEvent: refetch,
        saved,
        setCreateEventStage,
        setErrors,
        setFormData,
        setShowBlackBaudModal,
        setShowEmbedModal,
        setShowErrorModal,
        setShowPublishConfirmation,
        setShowStripeRequiredModal,
        showErrorModal,
        showBlackBaudModal,
        showEmbedModal,
        showPublishConfirmation,
        showStripeRequiredModal,
        paymentSelectionReady,
        paymentSettings,
        paymentSettingsLoading,
        selectedPaymentProcessor,
        toggleFundraising,
        togglePremium,
        urlEventId,
        validationRules,
        zapierSyncMessage
    };
};
const EventEditorProvider = (param)=>{
    let { children  } = param;
    const editor = useEventEditorState();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateEventContext/* CreateEventContext.Provider */.s.Provider, {
        value: editor,
        children: children
    });
};
const useEventEditor = ()=>(0,react.useContext)(CreateEventContext/* CreateEventContext */.s);


/***/ }),

/***/ 52992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ isGoCardlessEnabled; }
/* harmony export */ });
const isGoCardlessEnabled = ()=>{
    var ref;
    return ((ref = "false") === null || ref === void 0 ? void 0 : ref.trim().toLowerCase()) === "true";
};


/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useBlackBaud; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
// EXTERNAL MODULE: ./libs/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(3830);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/organisation/connectToBlackBaud.ts

const CONNECT_TO_BLACKBAUD = (0,_generated/* graphql */.B)("\n  mutation connectToBlackBaud(\n    $name: String!\n    $code: String!\n    $codeVerifier: String!\n    $clientId: String!\n    $redirectUri: String!\n  ) {\n    connectToBlackBaud(\n      name: $name\n      code: $code\n      codeVerifier: $codeVerifier\n      clientId: $clientId\n      redirectUri: $redirectUri\n    ) {\n      success\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/pushToBlackbaud.ts

const PUSH_TO_BLACKBAUD = (0,_generated/* graphql */.B)("\n  mutation pushToBlackbaud(\n    $eventId: String!\n    $blackbaudId: String\n    $fields: [String!]!\n    $updatedConstituents: [UpdatedConstituentInput!]\n  ) {\n    pushToBlackbaud(\n      eventId: $eventId\n      blackbaudId: $blackbaudId\n      fields: $fields\n      updatedConstituents: $updatedConstituents\n    ) {\n      success\n      completed\n      error\n      isOrganizer\n      blackBaudAccessToken\n      orgName\n      currentBlackbaudId\n      newBlackbaudId\n      bbServiceInitialized\n      bbPrimaryAccessKey\n      bbUrl\n      eventPreUpdate\n      eventPostUpdate\n      eventUpdated\n      eventId\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/getBlackBaudEventQuery.ts

const GET_BLACKBAUD_EVENT_BY_ID = (0,_generated/* graphql */.B)("\n  mutation getBlackBaudEvent($eventId: String!, $blackbaudId: String) {\n    getBlackBaudEvent(eventId: $eventId, blackbaudId: $blackbaudId) {\n      id\n      name\n      description\n      start_date\n      start_time\n      end_date\n      end_time\n      attendees {\n        name\n        email\n        summary_note\n        contact_id\n      }\n      speakers {\n        name\n        email\n        summary_note\n        contact_id\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./libs/useBlackBaud.ts







const CLIENT_ID = "147edada-78d2-41da-8684-ab05ee42132c";
const REDIRECT_URI = "https://app.forumm.to/organisation-settings";
const useBlackBaud = ()=>{
    const [connectToBlackBaud] = (0,useMutation/* useMutation */.D)(CONNECT_TO_BLACKBAUD);
    const [pushToBlackbaud] = (0,useMutation/* useMutation */.D)(PUSH_TO_BLACKBAUD);
    const [getBlackBaudEvent] = (0,useMutation/* useMutation */.D)(GET_BLACKBAUD_EVENT_BY_ID);
    const [accessToken, setAccessToken] = (0,react.useState)(null);
    const [completed, setCompleted] = (0,react.useState)(false);
    const [lsCodeVerifier, setCodeVerifier] = (0,useLocalStorage/* default */.Z)("BlackBaud_CodeVerifier", "");
    const base64URLEncode = (str)=>{
        return str.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    };
    const initiateOAuth = (0,react.useCallback)(()=>{
        const newState = crypto_browserify_default().randomBytes(48).toString("hex");
        const codeVerifier = base64URLEncode(crypto_browserify_default().randomBytes(32));
        setCodeVerifier(codeVerifier);
        const challengeDigest = crypto_browserify_default().createHash("sha256").update(codeVerifier).digest();
        const newCodeChallenge = base64URLEncode(challengeDigest);
        const authUrl = "https://app.blackbaud.com/oauth/authorize?response_type=code&client_id=".concat(CLIENT_ID, "&redirect_uri=").concat(encodeURIComponent(REDIRECT_URI), "&state=").concat(newState, "&code_challenge=").concat(newCodeChallenge, "&code_challenge_method=S256");
        window.location.href = authUrl;
    }, []);
    const onCallback = (0,react.useCallback)(async (url, name, onCompleteAction)=>{
        if (completed) return;
        const urlParams = new URLSearchParams(new URL(url).search);
        const code = urlParams.get("code");
        let error = urlParams.get("error");
        if (error || !code) {
            console.error("Error during authentication: ", error);
            return;
        }
        const response = await connectToBlackBaud({
            variables: {
                codeVerifier: lsCodeVerifier,
                clientId: CLIENT_ID,
                redirectUri: REDIRECT_URI,
                code,
                name
            }
        });
        if (onCompleteAction) {
            setTimeout(()=>{
                onCompleteAction();
            }, 100);
        }
        setCompleted(true);
    }, // eslint-disable-next-line
    [
        connectToBlackBaud,
        completed,
        setCompleted
    ]);
    const publish = (0,react.useCallback)(async (eventId, fields, updatedConstituents, blackbaudId)=>{
        console.log("WILL PUBLISH:", {
            eventId,
            fields,
            blackbaudId,
            updatedConstituents
        });
        return await pushToBlackbaud({
            variables: {
                eventId,
                fields,
                blackbaudId,
                updatedConstituents
            }
        });
    }, [
        pushToBlackbaud
    ]);
    const getEvent = (0,react.useCallback)(async (eventId, blackbaudId)=>{
        const response = await getBlackBaudEvent({
            variables: {
                eventId,
                blackbaudId
            }
        });
        return response;
    }, [
        pushToBlackbaud
    ]);
    return {
        initiateOAuth,
        onCallback,
        accessToken,
        completed,
        publish,
        getEvent
    };
};


/***/ })

}]);